/**
 * step(state, commands, config) → state — en sim-tick vid fast 20 tps.
 * Ren transitionsfunktion: ingen global state, ingen tidskälla, ingen
 * Math.random. Samma (state, commands, config) ger alltid samma resultat.
 * State muteras på plats och returneras (prestanda-budget: ingen GC-churn).
 */
import type { Command } from './commands';
import type { SimConfig } from './config';
import { clamp, fpFromWorld } from './fixed';
import { moveMotherships, moveUnits } from './movement';
import { updateSpawning } from './spawn';
import type { GameState } from './state';
import { PLAYER_IDS } from './state';

function applyCommand(state: GameState, command: Command, config: SimConfig): void {
  const maxX = fpFromWorld(config.match.mapSize.width);
  const maxY = fpFromWorld(config.match.mapSize.height);

  switch (command.type) {
    case 'MoveShip': {
      const ship = state.motherships[command.playerId];
      ship.targetX = clamp(command.x, 0, maxX);
      ship.targetY = clamp(command.y, 0, maxY);
      break;
    }
    case 'SetStance': {
      state.players[command.playerId].stance = command.stance;
      break;
    }
    case 'SetRallyPoint': {
      const p = state.players[command.playerId];
      p.rallyPoint = command.point
        ? { x: clamp(command.point.x, 0, maxX), y: clamp(command.point.y, 0, maxY) }
        : null;
      break;
    }
  }
}

export function step(state: GameState, commands: Command[], config: SimConfig): GameState {
  if (state.winner !== null) return state;

  for (const command of commands) applyCommand(state, command, config);

  for (const id of PLAYER_IDS) {
    const ship = state.motherships[id];
    if (ship.retreatTicksLeft > 0) ship.retreatTicksLeft--;
  }

  updateSpawning(state, config);
  moveMotherships(state, config);
  moveUnits(state, config);

  state.tick++;
  return state;
}
